import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  button: {
    flexShrink: 0,
    alignSelf: "start",
    justifySelf: "end",
    ...shorthands.margin("18px"),
    color: tokens.colorBrandForeground1,
    cursor: "pointer",
  },
});
